module.exports = __webpack_public_path__ + "static/media/landing-header-background.5ad8dcf9.jpg";